import get from 'lodash/fp/get';
import { createSelector } from 'reselect';

const selectAppSession = (state) => get(['app', 'session'], state);

const selectUser = createSelector(selectAppSession, (session) => session.user);

export default selectUser;
